const SESSIONID = "PARMONIC_SESSION_ID"
export class LocalStorageService {
  public setSessionId(id: string) {
    localStorage[SESSIONID] = id
  }
  public getSessionId(): string | null {
    return localStorage[SESSIONID]
  }
}
